import React, { useCallback } from 'react';
import Logo from '../../../assets/logos/logo-small.svg';
import Button from '../../atom/Button';
import Typo from '../../atom/Typo';
import RadixIcon from '../../atom/Icons/RadixIcon';
import { Link, useNavigate } from 'react-router-dom';
import PATH from '@/src/routes/path';
import { BUTTON_CONST } from '@/src/constants/buttons';
import useAuthStore from '@/src/store/useAuthStore';
import { useMutation } from '@tanstack/react-query';
import { postSignOutAPI } from '@/src/apis/rest/administrators';
import { useToast } from '@/hooks/useToast';
import useDialog, { DialogType } from '@/hooks/useDialog';

function MainHeader() {
  const navigate = useNavigate();

  const { toast } = useToast();
  const user = useAuthStore(state => state.auth);
  const signOut = useAuthStore(state => state.signOut);

  const { Dialog, openDialog, isOpen, closeDialog } = useDialog({
    type: DialogType.ALERT,
  });

  const postSignOut = useMutation({
    mutationFn: () => postSignOutAPI(),
  });

  const mutateSignOut = async () => {
    try {
      await postSignOut.mutateAsync();
      signOut();
      closeDialog();
      navigate(PATH.LOGIN, { replace: true });
      toast({
        title: '로그아웃 성공',
        description: '성공적으로 로그아웃 되었습니다. 다시 로그인해주세요',
        variant: 'success',
      });
    } catch (e) {
      closeDialog();
      toast({
        title: BUTTON_CONST.logout,
        description: '로그아웃에 실패했습니다.',
        variant: 'error',
      });
    }
  };

  const handleLogoutClick = useCallback(() => {
    openDialog();
  }, [openDialog]);

  return (
    <>
      <Dialog
        open={isOpen}
        onOpenChange={closeDialog}
        cancelText={BUTTON_CONST.cancel}
        okText={BUTTON_CONST.logout}
        title="로그아웃 안내"
        onOk={mutateSignOut}
      >
        정말 로그아웃 하시겠습니까?
      </Dialog>
      <header className="flex items-center justify-between bg-white px-10 py-[18px]">
        <img
          className="cursor-pointer"
          src={Logo}
          alt="logo"
          onClick={() => {
            navigate(PATH.ROOT);
          }}
        />
        <div />

        <div className="flex items-center gap-x-4">
          {/* 한영 전환 */}
          {/* <div className="flex items-center gap-x-1">
          <LucideIcon name="Globe" />
          <Typo
            className="cursor-pointer"
            onClick={() => {
              return setLang('en');
            }}
            typoColor={lang === 'en' ? 'gray9' : 'gray4'}
          >
            EN
          </Typo>
          <div>|</div>
          <Typo
            className="cursor-pointer"
            onClick={() => {
              return setLang('ko');
            }}
            typoColor={lang === 'ko' ? 'gray9' : 'gray4'}
          >
            KOR
          </Typo>
        </div> */}

          {/* 유저정보  */}
          <Link to={PATH.ADMINISTRATOR_DETAIL.replace(':id', String(user?.id))}>
            <div className="flex items-center gap-x-1">
              <RadixIcon name="PersonIcon" />
              <Typo>{user?.name}</Typo>
            </div>
          </Link>

          {/* 로그아웃 */}
          <Button
            buttonSize="xSmall"
            buttonColor="outline"
            onClick={handleLogoutClick}
          >
            {BUTTON_CONST.logout}
          </Button>
        </div>
      </header>
    </>
  );
}

export default MainHeader;
